var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomBlock4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 200,
    viewBox: "0 0 400 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 200,
    fill: "#F6F6FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2013_2251)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 112,
    transform: "translate(0 44)",
    fill: "#B5C3E5"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 44,
    width: 400,
    height: 112,
    fill: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -152.735,
    y1: 49.6568,
    x2: 164.049,
    y2: -267.127,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -145.664,
    y1: 56.7279,
    x2: 171.12,
    y2: -260.056,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -138.593,
    y1: 63.799,
    x2: 178.191,
    y2: -252.985,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -131.522,
    y1: 70.87,
    x2: 185.262,
    y2: -245.914,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -124.451,
    y1: 77.9411,
    x2: 192.333,
    y2: -238.843,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -117.38,
    y1: 85.0122,
    x2: 199.404,
    y2: -231.772,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -110.309,
    y1: 92.0832,
    x2: 206.475,
    y2: -224.701,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -103.238,
    y1: 99.1544,
    x2: 213.546,
    y2: -217.629,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -96.1664,
    y1: 106.225,
    x2: 220.617,
    y2: -210.558,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -89.0954,
    y1: 113.296,
    x2: 227.688,
    y2: -203.487,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -82.0243,
    y1: 120.368,
    x2: 234.76,
    y2: -196.416,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -74.9533,
    y1: 127.439,
    x2: 241.831,
    y2: -189.345,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -67.8822,
    y1: 134.51,
    x2: 248.902,
    y2: -182.274,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.8112,
    y1: 141.581,
    x2: 255.973,
    y2: -175.203,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -53.7401,
    y1: 148.652,
    x2: 263.044,
    y2: -168.132,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -46.6691,
    y1: 155.723,
    x2: 270.115,
    y2: -161.061,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -39.5981,
    y1: 162.794,
    x2: 277.186,
    y2: -153.99,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -32.527,
    y1: 169.865,
    x2: 284.257,
    y2: -146.919,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -25.456,
    y1: 176.936,
    x2: 291.328,
    y2: -139.848,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -18.3847,
    y1: 184.007,
    x2: 298.399,
    y2: -132.777,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -11.3136,
    y1: 191.078,
    x2: 305.47,
    y2: -125.706,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.24258,
    y1: 198.149,
    x2: 312.541,
    y2: -118.635,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.82846,
    y1: 205.22,
    x2: 319.612,
    y2: -111.564,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.89951,
    y1: 212.291,
    x2: 326.683,
    y2: -104.493,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.9706,
    y1: 219.362,
    x2: 333.754,
    y2: -97.4215,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.0416,
    y1: 226.434,
    x2: 340.825,
    y2: -90.3503,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.1126,
    y1: 233.505,
    x2: 347.897,
    y2: -83.2793,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.1837,
    y1: 240.576,
    x2: 354.968,
    y2: -76.2082,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.2547,
    y1: 247.647,
    x2: 362.039,
    y2: -69.137,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.326,
    y1: 254.718,
    x2: 369.11,
    y2: -62.066,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.3971,
    y1: 261.789,
    x2: 376.181,
    y2: -54.9949,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.4681,
    y1: 268.86,
    x2: 383.252,
    y2: -47.9239,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.5392,
    y1: 275.931,
    x2: 390.323,
    y2: -40.8529,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6102,
    y1: 283.002,
    x2: 397.394,
    y2: -33.7818,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.6812,
    y1: 290.073,
    x2: 404.465,
    y2: -26.7108,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.7523,
    y1: 297.144,
    x2: 411.536,
    y2: -19.6397,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.823,
    y1: 304.215,
    x2: 418.607,
    y2: -12.5686,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.894,
    y1: 311.286,
    x2: 425.678,
    y2: -5.49751,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.965,
    y1: 318.357,
    x2: 432.749,
    y2: 1.57353,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.036,
    y1: 325.429,
    x2: 439.82,
    y2: 8.6447,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.108,
    y1: 332.5,
    x2: 446.892,
    y2: 15.7157,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.179,
    y1: 339.571,
    x2: 453.963,
    y2: 22.7868,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.25,
    y1: 346.642,
    x2: 461.034,
    y2: 29.8578,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.321,
    y1: 353.713,
    x2: 468.105,
    y2: 36.9289,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.392,
    y1: 360.784,
    x2: 475.176,
    y2: 43.9999,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.463,
    y1: 367.855,
    x2: 482.247,
    y2: 51.071,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.534,
    y1: 374.926,
    x2: 489.318,
    y2: 58.142,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.605,
    y1: 381.997,
    x2: 496.389,
    y2: 65.2132,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.676,
    y1: 389.068,
    x2: 503.46,
    y2: 72.2842,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.747,
    y1: 396.139,
    x2: 510.531,
    y2: 79.3554,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.818,
    y1: 403.21,
    x2: 517.602,
    y2: 86.4264,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 207.889,
    y1: 410.281,
    x2: 524.673,
    y2: 93.4975,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.961,
    y1: 417.352,
    x2: 531.744,
    y2: 100.569,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.032,
    y1: 424.423,
    x2: 538.815,
    y2: 107.64,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.103,
    y1: 431.494,
    x2: 545.886,
    y2: 114.711,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.174,
    y1: 438.566,
    x2: 552.958,
    y2: 121.782,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.245,
    y1: 445.637,
    x2: 560.029,
    y2: 128.853,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.316,
    y1: 452.708,
    x2: 567.1,
    y2: 135.924,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.387,
    y1: 459.779,
    x2: 574.171,
    y2: 142.995,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.458,
    y1: 466.85,
    x2: 581.242,
    y2: 150.066,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.529,
    y1: 473.921,
    x2: 588.313,
    y2: 157.137,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.651 112.39C112.877 112.39 111.221 112.097 109.685 111.513C108.17 110.907 106.84 110.063 105.693 108.982C104.546 107.9 103.648 106.634 102.999 105.184C102.371 103.713 102.058 102.122 102.058 100.413C102.058 98.6818 102.371 97.0914 102.999 95.6416C103.648 94.1919 104.535 92.9369 105.66 91.8766C106.807 90.8163 108.138 89.9941 109.653 89.4099C111.167 88.804 112.812 88.5011 114.586 88.5011C116.382 88.5011 118.027 88.7824 119.52 89.345C121.013 89.9075 122.311 90.6865 123.414 91.6819L119.098 96.0311C118.578 95.4685 117.94 95.025 117.183 94.7004C116.447 94.3758 115.581 94.2135 114.586 94.2135C113.721 94.2135 112.92 94.3542 112.184 94.6355C111.47 94.9168 110.854 95.3279 110.334 95.8688C109.815 96.4098 109.404 97.0698 109.101 97.8487C108.82 98.6061 108.679 99.4608 108.679 100.413C108.679 101.387 108.82 102.263 109.101 103.042C109.404 103.799 109.815 104.448 110.334 104.989C110.854 105.53 111.47 105.952 112.184 106.255C112.92 106.536 113.721 106.677 114.586 106.677C115.56 106.677 116.425 106.526 117.183 106.223C117.962 105.92 118.632 105.476 119.195 104.892L123.544 109.241C122.397 110.237 121.11 111.016 119.682 111.578C118.254 112.119 116.577 112.39 114.651 112.39Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.797 112.39C134.763 112.39 132.989 111.978 131.474 111.156C129.959 110.312 128.78 109.155 127.936 107.683C127.092 106.212 126.67 104.524 126.67 102.62V88.8906H133.162V103.204C133.162 103.94 133.324 104.567 133.649 105.087C133.973 105.606 134.406 106.006 134.947 106.288C135.509 106.547 136.126 106.677 136.797 106.677C137.489 106.677 138.095 106.547 138.615 106.288C139.155 106.006 139.577 105.617 139.88 105.119C140.183 104.6 140.335 103.972 140.335 103.237V88.8906H146.859V102.652C146.859 104.557 146.437 106.244 145.593 107.716C144.771 109.165 143.602 110.312 142.087 111.156C140.594 111.978 138.831 112.39 136.797 112.39Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.772 112.39C156.803 112.39 155.083 112.108 153.611 111.546C152.162 110.961 150.82 110.042 149.587 108.787L153.644 104.73C154.488 105.53 155.375 106.147 156.305 106.58C157.236 106.991 158.231 107.196 159.291 107.196C160.179 107.196 160.849 107.067 161.304 106.807C161.758 106.526 161.985 106.147 161.985 105.671C161.985 105.195 161.791 104.805 161.401 104.502C161.012 104.178 160.492 103.897 159.843 103.659C159.216 103.399 158.513 103.139 157.734 102.88C156.976 102.62 156.219 102.306 155.462 101.938C154.704 101.57 154.001 101.127 153.352 100.608C152.724 100.067 152.216 99.4067 151.826 98.6277C151.437 97.8271 151.242 96.8534 151.242 95.7066C151.242 94.2135 151.599 92.9261 152.313 91.8442C153.027 90.7623 154.033 89.94 155.332 89.3774C156.63 88.7932 158.155 88.5011 159.908 88.5011C161.639 88.5011 163.24 88.7824 164.712 89.345C166.205 89.8859 167.438 90.6649 168.412 91.6819L164.322 95.739C163.608 95.0466 162.894 94.5381 162.18 94.2135C161.466 93.8673 160.687 93.6942 159.843 93.6942C159.172 93.6942 158.632 93.8024 158.22 94.0188C157.831 94.2352 157.636 94.5597 157.636 94.9925C157.636 95.4469 157.831 95.8256 158.22 96.1285C158.61 96.4098 159.118 96.6695 159.746 96.9075C160.395 97.1455 161.098 97.3943 161.856 97.654C162.635 97.9136 163.403 98.2274 164.16 98.5952C164.917 98.9415 165.61 99.3959 166.237 99.9584C166.886 100.499 167.406 101.181 167.795 102.003C168.185 102.825 168.379 103.821 168.379 104.989C168.379 107.348 167.536 109.176 165.848 110.475C164.182 111.751 161.823 112.39 158.772 112.39Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.173 112V88.8906H183.664V112H177.173ZM170.259 94.4083V88.8906H190.61V94.4083H170.259Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.854 112.454C203.036 112.454 201.359 112.152 199.823 111.546C198.308 110.94 196.978 110.096 195.831 109.014C194.706 107.932 193.829 106.655 193.202 105.184C192.574 103.713 192.261 102.122 192.261 100.413C192.261 98.6818 192.564 97.0914 193.169 95.6416C193.797 94.1919 194.673 92.9261 195.798 91.8442C196.924 90.7623 198.244 89.9292 199.758 89.345C201.294 88.7391 202.971 88.4362 204.789 88.4362C206.607 88.4362 208.273 88.7391 209.787 89.345C211.324 89.9292 212.654 90.7623 213.78 91.8442C214.905 92.9261 215.77 94.2027 216.376 95.6741C217.004 97.1239 217.317 98.7143 217.317 100.445C217.317 102.155 217.004 103.745 216.376 105.216C215.77 106.666 214.905 107.943 213.78 109.046C212.654 110.128 211.335 110.972 209.82 111.578C208.305 112.162 206.65 112.454 204.854 112.454ZM204.789 106.742C206.001 106.742 207.05 106.482 207.937 105.963C208.825 105.444 209.506 104.708 209.982 103.756C210.458 102.804 210.696 101.689 210.696 100.413C210.696 99.4608 210.556 98.6061 210.274 97.8487C210.015 97.0698 209.625 96.4098 209.106 95.8688C208.587 95.3063 207.959 94.8843 207.223 94.603C206.509 94.3001 205.698 94.1486 204.789 94.1486C203.577 94.1486 202.528 94.4083 201.641 94.9276C200.754 95.4253 200.072 96.1501 199.596 97.1022C199.12 98.0327 198.882 99.1362 198.882 100.413C198.882 101.387 199.012 102.263 199.271 103.042C199.553 103.821 199.953 104.492 200.472 105.054C200.992 105.595 201.608 106.017 202.322 106.32C203.058 106.601 203.88 106.742 204.789 106.742Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.289 112V88.8906H225.995L234.596 101.484H232.552L241.12 88.8906H245.827V112H239.4V99.5365L240.341 99.7962L235.635 106.547H231.48L226.807 99.7962L227.715 99.5365V112H221.289Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.427 112L270.452 88.8906H275.515L271.458 112H266.427ZM257.047 105.736V101.516H276.327V105.736H257.047ZM258.8 112L262.857 88.8906H267.856L263.863 112H258.8ZM258.216 98.8874V94.7004H277.463V98.8874H258.216Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.079 104.21L287.025 88.8906H293.906L286.798 104.21H280.079ZM280.079 107.683V104.21L281.832 102.36H299.164V107.683H280.079ZM290.92 112V98.4979H297.249V112H290.92Z",
    fill: "#2C314F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2013_2251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 112,
    fill: "white",
    transform: "translate(0 44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomBlock4);
export default __webpack_public_path__ + "static/media/custom-block-4.e2fd5c2a651edb879991f040f5d6717d.svg";
export { ForwardRef as ReactComponent };